/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './actionTypes';

const initialState = {
  planType: [],
  rebateProgramList: [],
  rebateProgramNameValue: '',
  selectedPlanType: '',
  rebateProgramValue: '',

  errors: [],
  fromDateValue: '',
  toDateValue: '',
  rebateProgramName: '',
  searchResult: [],
  excludedClaimsDropDown: [],

  isLoading: false,

  allRebateProgram: false,
  allNonInvoice: false,
  nonInvoiceSelected: '',
  nonInvoiceToggle: '',
  dropDownList: [],
  displayObj: {
    rebateProgramName: '',
    rebateProgramList: [],
    rebateProgramValue: '',
    fromDateValue: '',
    toDateValue: '',
    searchResult: [],
    allRebateProgram: false,
    dropDownList: [],
    nonInvoiceToggle: '',
  },
  isNetworkError: false,
  pdfPrev: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };
    case ActionTypes.SET_ALL_NON_INVOICE_DATA:
     return { ...state, allNonInvoice: action.payload };
     case ActionTypes.SET_REBATE_PROGRAM_DATA:
     return { ...state, allRebateProgram: action.payload };
    case ActionTypes.GET_REBATE_PROGRAM_EXCLUDED_CLAIMS:
      return { ...state, rebateProgramList: action.payload };
    case ActionTypes.SET_SELECTED_INPUT_EXCLUDED_CLAIMS:
      return { ...state, ...action.payload };
    case ActionTypes.IS_LOADING_EXCLUDED_CLAIMS:
      return { ...state, isLoading: action.isLoading };
    case ActionTypes.SET_NEWORK_ERROR:
      return { ...state, isNetworkError: action.payload };
      case ActionTypes.GENERATE_PDF_DATA:
        return {
          ...state,
          pdfPrev: action.pdfPrev,
        };
    // For Drop down
    case ActionTypes.EXCLUDED_CLAIMS_DROP_DOWN:
      return {
        ...state,
        excludedClaimsDropDown: action.excludedClaimsDropDown,
      };
    // For Result Grid
    case ActionTypes.EXCLUDED_CLAIMS_RESULT_GRID:
      const displayObj = {
        ...state.displayObj,
        searchResult: action.searchResult,
      };
      return {
        ...state,
        searchResult: action.searchResult,
        displayObj,
      };

    case ActionTypes.SET_PAGINATION_INDEX_EXCLUDED_CLAIMS:
      return {
        ...state,
        displayObj: { ...state.displayObj, countValue: action.payload },
      };

    case ActionTypes.REFRESH_EXCLUDED_CLAIMS:
      return {
        ...initialState,
        displayObj: state.displayObj,
      };
    default:
      return state;
  }
};

export default reducer;
